import { render, staticRenderFns } from "./CounterpartiesUpdateComponent.vue?vue&type=template&id=5209e9ba&scoped=true"
import script from "./CounterpartiesUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./CounterpartiesUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209e9ba",
  null
  
)

export default component.exports